/*
 * Who a notification is for. Shared by the app (which messages to show this profile), the
 * admin composer (how many people it reaches) and the Cloud Function that sends the push
 * (functions/audience.js is this file in CommonJS; keep them identical).
 *
 * An audience is { roles: [], sites: [], divisions: [] }. Empty lists mean "everyone"; a
 * non-empty list narrows. A resident's site is their current rotation. Alumni get nothing.
 */

export const isAlumniProfile = (p, now = new Date()) => Boolean(p && p.gradYear && (now.getFullYear() > p.gradYear || (now.getFullYear() === p.gradYear && now.getMonth() >= 6)));

export const siteOfProfile = (p) => (p && p.role === 'resident' ? p.rotation || null : (p && p.site) || null);

export const isEveryone = (a) => !a || ((a.roles || []).length === 0 && (a.sites || []).length === 0 && (a.divisions || []).length === 0);

/** Does this profile (or null for a signed-out device) belong to the audience? */
export const inAudience = (audience, profile, now = new Date()) => {
  if (isEveryone(audience)) return true;
  if (!profile || !profile.role) return false;
  if (isAlumniProfile(profile, now)) return false;
  const roles = audience.roles || []; const sites = audience.sites || []; const divisions = audience.divisions || [];
  if (roles.length && !roles.includes(profile.role)) return false;
  if (sites.length && !sites.includes(siteOfProfile(profile))) return false;
  if (divisions.length && !divisions.includes(profile.division)) return false;
  return true;
};

const ROLE_PLURAL = { student: 'students', resident: 'residents', fellow: 'fellows', app: 'APPs', attending: 'attendings' };
const list = (xs) => (xs.length <= 1 ? xs.join('') : `${xs.slice(0, -1).join(', ')} and ${xs[xs.length - 1]}`);

/** "Everyone", "Residents and fellows at Texas Heart Institute", "Cardiovascular Critical Care at Texas Heart Institute" */
export const describeAudience = (a) => {
  if (isEveryone(a)) return 'Everyone';
  const roles = (a.roles || []).map((r) => ROLE_PLURAL[r] || r);
  const who = roles.length ? list(roles) : 'everyone';
  const where = (a.divisions || []).length ? list(a.divisions) : '';
  const at = (a.sites || []).length ? ` at ${list(a.sites)}` : '';
  const text = where ? (roles.length ? `${who} in ${where}${at}` : `${where}${at}`) : `${who}${at}`;
  return text.charAt(0).toUpperCase() + text.slice(1);
};
